
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17 27.2c-3.638 0-6.834-1.224-9.656-3.06-2.754-1.768-5.1-4.114-7.072-6.426a1.138 1.138 0 010-1.496c2.176-2.516 5.066-5.1 8.262-6.936C11.22 7.786 14.11 6.8 17 6.8c2.89 0 5.78.986 8.466 2.516 3.162 1.836 6.052 4.42 8.262 6.936a1.138 1.138 0 010 1.496c-2.006 2.278-4.352 4.624-7.072 6.392-2.822 1.836-6.018 3.06-9.656 3.06z","fill":"#000"}}),_c('path',{attrs:{"d":"M8.568 22.27c2.482 1.598 5.27 2.686 8.432 2.686 3.162 0 5.95-1.088 8.432-2.686 2.244-1.462 4.216-3.332 5.95-5.236-1.938-2.108-4.386-4.216-7.004-5.712-2.346-1.36-4.862-2.21-7.344-2.21-2.448 0-4.964.884-7.344 2.21-2.686 1.496-5.1 3.57-7.038 5.678 1.7 1.904 3.706 3.808 5.916 5.27z","fill":"#fff"}}),_c('path',{attrs:{"d":"M17 10.438a6.61 6.61 0 014.658 1.938 6.55 6.55 0 011.938 4.658 6.61 6.61 0 01-1.938 4.658A6.55 6.55 0 0117 23.63a6.61 6.61 0 01-4.658-1.938 6.55 6.55 0 01-1.938-4.658 6.61 6.61 0 011.938-4.658A6.528 6.528 0 0117 10.438z","fill":"#000"}}),_c('path',{attrs:{"d":"M20.06 13.94A4.317 4.317 0 0017 12.682c-1.19 0-2.278.476-3.06 1.258A4.317 4.317 0 0012.682 17c0 1.19.476 2.278 1.258 3.06A4.317 4.317 0 0017 21.318c1.19 0 2.278-.476 3.06-1.258A4.317 4.317 0 0021.318 17c0-1.19-.51-2.278-1.258-3.06z","fill":"#fff"}})])
          )
        }
      }
    